import BindingContext from '@/BindingContext';
import ComponentManager from '@/Management/ComponentManager';
import RADApplication from '@/Management/RADApplication';
import ResourceManager from '@/Management/ResourceManager';
import StorageHelper from '@/Utility/StorageHelper';
import ImageHandler from '@/Utility/ImageHandler';
import ViewTuple from '@/Views/ViewTuple';
import ViewViewModel from '@/ViewModels/ViewViewModel';

/**
* Repräsentiert die Oberklasse aller Views
*/
export default class View extends BindingContext {

    public tuple: ViewTuple;

    public constructor() {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        throw new Error('Die Funktion "getView" wurde nicht implementiert');
    }

    /**
    * Erzeugt das ViewTuple und die View
    */
    public getTuple(): ViewTuple {
        if (this.tuple)
            return this.tuple;

        const $view = this.getView();
        this.tuple = new ViewTuple(this, $view);
        return this.tuple;
    }

    /**
     * Wendet Bindings auf ein Template an
     */
    public applyBindings(element: JQuery<HTMLElement>, viewModel: ViewViewModel, html: string): JQuery<HTMLElement> {
        let parsedHTML = ImageHandler.parseHTML(html);
        let view = element.append($(parsedHTML));
        return this.applyViewBindings(view, viewModel);
    }

    /**
     * Rendert ein KoElement und bindet es an die View.
     */
    public applyJsxBindings(element: JQuery<HTMLElement>, viewModel: ViewViewModel, jsxElement: KnockoutJsxElement): JQuery<HTMLElement> {
        const node = ko.jsx.render(jsxElement).node;
        const view = element.empty().append($(node as HTMLElement));
        return this.applyViewBindings(view, viewModel);
    }

    private applyViewBindings(view:JQuery<HTMLElement>, viewModel: ViewViewModel) {
        ko.applyBindings({
            uiElement: this,
            viewModel: viewModel,
            RADApplication: RADApplication,
            ResourceManager: ResourceManager,
            StorageHelper: StorageHelper
        }, view[0]);

        ko.applyBindingsToNode(view[0], {
            loader: viewModel.isBusy
        });

        return view;
    }

    /**
     * Wendet Bindings auf ein DOM-Element an
     */
    public applyBindingsToNode(element: JQuery<HTMLElement>, bindings: Object): void {
        if (element[0] == null) {
            throw 'Bindings können nicht angewendet werden. Element ist null.';
        }

        ko.applyBindingsToNode(element[0], $.extend({ uiElement: this }, bindings));
    }

    /**
     * Erzeugt eine neue Instanz einer View anhand einer Komponentenbezeichnung
     */
    public static createInstance(component: string, viewModel: ViewViewModel, element: JQuery<HTMLElement>): View {
        let Component = ComponentManager.getView(component) as any;

        if (Component == null) {
            throw 'View-Komponente "' + component + '" wurde nicht gefunden.';
        }

        return new Component(viewModel, element);
    }
}
